import { type Enum } from '@webapp/infrastructure/types/Enum'

export const ConversationDetailBlockTypes = {
  TEXT: 'text',
  KEY_VALUE: 'key_value',
  TABLE: 'table',
  LIST: 'list',
  CHIPS: 'chips',
} as const

export type ConversationDetailBlockTypeEnum = Enum<
  typeof ConversationDetailBlockTypes
>
